import type { HelpFile } from '../../types/help'
import { SpanWaterfallTestIds } from '../../../testids/SpanWaterfallTestIds'

export const spanWaterfallHelp: HelpFile = {
  docPage: '/docs/observability/traces',
  texts: {
    [SpanWaterfallTestIds.spanWaterfall]: 'Wasserfall-Ansicht aller Spans eines Traces, die zeigt, wie eine Anfrage über Dienste und Komponenten hinweg verarbeitet wurde.',
    [SpanWaterfallTestIds.colDuration]: 'Dauer, die der Span benötigt hat.',
    [SpanWaterfallTestIds.colSpan]: 'Span-Name und Operation, eingerückt entsprechend der Eltern-Kind-Beziehung.',
    [SpanWaterfallTestIds.colStatus]: 'Ergebnis des Spans (OK, Fehler, abgebrochen).',
    [SpanWaterfallTestIds.filterAll]: null,
    [SpanWaterfallTestIds.sortDuration]: null,
    [SpanWaterfallTestIds.sortTime]: null,
  },
}
